import { serializeRecommendationProductsFromApi } from '../../../../store/helpers/serializers/recommendationProduct';
import { RecommendationProducts } from '../../../../store/recommendationProducts/types';
import {
  eaptekaApi,
  responseHandler
} from '../../eaptekaApi';
import { ApiRecommendationProducts } from './types';

export const eaptekaApiRequestRecommendationProductsGet =
  eaptekaApi.createPostMethod('/recommendationProduct', {
    mapRequest: (params) => ({
      body: JSON.stringify(params)
    }),
    mapResponse: async (response) =>
      responseHandler<
        RecommendationProducts,
        ApiRecommendationProducts
      >(response, serializeRecommendationProductsFromApi)
  });
